interface RitualFrequencySelectProps {
  onChange: React.ChangeEventHandler<HTMLSelectElement>
  frequency: number
}
export default function RitualFrequencySelect({
  onChange,
  frequency,
}: RitualFrequencySelectProps) {
  const numberOfFrequencyOptions = Array.from(Array(4).keys())

  return (
    <label className="styled-select" data-component="ritual-frequency-select">
      <select onChange={onChange} value={`${frequency}`}>
        {numberOfFrequencyOptions.map((idxValue) => (
          <option
            key={`quantity_key_${idxValue}`}
            value={`${idxValue * 2 + 2}`}
          >
            Every {idxValue * 2 + 2} weeks
          </option>
        ))}
      </select>
    </label>
  )
}
